import { render, staticRenderFns } from "./Rent.vue?vue&type=template&id=38ec56a1&scoped=true&"
import script from "./Rent.vue?vue&type=script&lang=js&"
export * from "./Rent.vue?vue&type=script&lang=js&"
import style0 from "./Rent.vue?vue&type=style&index=0&id=38ec56a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ec56a1",
  null
  
)

export default component.exports